import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { TopReviewType } from '@ugc-components/ugc-pdp-review/interface';
import TopReviewItem from './top-review-item';

@Component({
  tag: 'ugc-review-top-review',
  shadow: false,
})
export class UgcReviewTopReview {
  render() {
    const {
      reviewSummary: { topPositiveReview, topCriticalReview },
    } = state;

    if (!topPositiveReview && !topCriticalReview) return null;

    return (
      <div class="flex-row-between-start mb-24">
        {topPositiveReview && <TopReviewItem type={TopReviewType.TopPositiveReview} />}
        {topCriticalReview && <TopReviewItem type={TopReviewType.TopCriticalReview} />}
      </div>
    );
  }
}
